
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { distributeWay } from '../BizTerms'

export default defineComponent({
  props: ['orderlist', 'loading'],
  setup () {
    const router = useRouter()
    const recall = (orderId: string) => {
      router.push('/map?id=' + orderId)
    }
    const detail = (orderId: string) => {
      router.push('/detail?id=' + orderId)
    }
    const urlStr = (orderId: string) => {
      return './upload/' + orderId + '/SideA.jpg?d=' + Math.random()
    }
    const paneHeight = document.body.clientHeight - 280
    const paymentStr = (payment: string) => {
      return payment === '1' ? 'クレジットカード' : '銀行振込'
    }

    return {
      recall,
      detail,
      urlStr,
      paneHeight,
      distributeWay,
      paymentStr
    }
  }
})
